module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicWide-Regular-f501833e410e9194894846ab64cbf2ea.woff";